// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1178":"1e137159","6251":"158bc065","6533":"68eb16bf","6681":"158bc065","7169":"cebd2c4d"}[chunkId] + ".chunk.css";
};